export default {"src":"/_next/static/media/text.891ba053.svg","height":43,"width":37,"blurWidth":0,"blurHeight":0};